import { ListRuleSetsRequest, RULE_SET_ROUTES } from "@zeal/common";
import { IAxiosInstance } from "../../../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../../../AbstractApiClient/IApiResponse";

export const listRuleSets = (axios: IAxiosInstance) => {
  return async (data: ListRuleSetsRequest) => {
    const response = await axios.noRetry.get<IApiResponse<any>>(
      RULE_SET_ROUTES.LIST_RULE_SETS.replace(":companyID", data.companyID),
      { params: { companyID: data.companyID } }
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
